<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <div class="zv-breadcrumb-wrap">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/data-output/consultation' }">安全咨询</el-breadcrumb-item>
            <el-breadcrumb-item>{{countryTitle}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="headContainer">
          <el-backtop target=".headContainer">
            <i class="el-icon-caret-top"></i>
          </el-backtop>
          <div class="answer_box">
            <div class="answer_title">{{formData.title}}</div>
            <div class="answer_title">
              <div class="answer_inline">
                <div class="answer_line_txt">地区/国家</div>
                <div class="answer_line_font">{{formData.full_area_name}}</div>
              </div>
              <div class="answer_inline">
                <div class="answer_line_txt">所在地</div>
                <div class="answer_line_font">{{formData.area_name}}</div>
              </div>
            </div>
            <div class="answer_title">
              <div class="answer_inline">
                <div class="answer_line_txt">事件类型</div>
                <div class="answer_line_font">{{formData.category}}</div>
              </div>
              <div class="answer_inline">
                <div class="answer_line_txt">紧急程度</div>
                <div class="answer_line_font">{{formData.level == 1 ? '一般':formData.level == 2 ? '紧急':'十分紧急'}}</div>
              </div>
            </div>
            <div class="answer_title">
              <div class="answer_inline">
                <div class="answer_line_txt">单位名称</div>
                <div class="answer_line_font">{{formData.unit}}</div>
              </div>
              <div class="answer_inline">
                <div class="answer_line_txt">上报日期</div>
                <div class="answer_line_font">{{$timeStamp(formData.update_time)}}</div>
              </div>
            </div>
            <p v-html="formData.content"></p>
          </div>
          <el-form ref="formData" :model="formData" label-width="130px">

            <el-form-item label="选择专家">
              <el-select filterable clearable v-model="formData.expert_id" placeholder="请选择">
                <el-option
                  v-for="item in expertArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="恐怖组织介绍">
              <quill-editor v-model="formData.reply"
                ref="myQuillEditor"
                class="editer"
                :options="editorOption">
              </quill-editor>
            </el-form-item>
           
            <el-form-item style="margin-top: 40px;">
              <el-button type="primary" @click="newSubmit">提交</el-button>
              <el-button @click="goToCountryBase">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import timeZoneSelect from "./time_zone";
import api from "./api";
import tokenService from "@/utils/services/token_service"
import {timestampToTime} from "@/mixins/tools.js"
export default {
  mixins: [timestampToTime],
  data() {
    return {
      formData: {},
      countryTitle: "回复", //标题
      editorOption: {
        placeholder: '请输入正文'
      },
      submit: true, //提交状态
      newConstruction: false, //返回状态
      expertArr: [],
    };
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill
    }
  },
  created() {
    this.expertListFn()
    this.infoCommonData()
    // console.log(this.$msg('dsdsdsdsdsdsdsdlafite'))
  },
  methods: {
    // infoCommonData
    infoCommonData() {
      let data = {
        id: this.$route.query.id,
      };
      api
        .inquiryInfo(data)
        .then(res => {
          this.formData = res.list
        })
        .catch(err => {
          this.$message(err);
        });
    },
    expertListFn() {
      // 获取城市列表
      let data = {
        pagesize: 9999
      };
      api
        .expertList(data)
        .then(res => {
          console.log(res)
          this.expertArr = res.list
        })
        .catch(err => {
          this.$message(err);
        });
    },

    // 提交并新建表单
    newSubmit() {
      let data = {
        id: this.$route.query.id,
        expert_id: this.formData.expert_id,
        reply: this.formData.reply
      }
      // 编辑状态
      api
        .inquiryReply(data)
        .then(res => {
          if (res.error_code == 0) {
            this.$message({
              message: "回复成功！",
              type: "success"
            });
            this.goToCountryBase();
          }
        })
        .catch(err => {
          this.$message.error(err.error_message);
        });
    },

    // 取消跳转原页面
    goToCountryBase() {
      this.$router.push({
        name: "consultation"
      });
    }
  }
};
</script>
<style lang="less" scoped>
  .answer_box {
    width: 800px;
    height: 400px;
    margin-left: 50px;
    margin-bottom: 50px;
    border: 1px solid #C0C4CC;
    .answer_title {
      display: flex;
      width: 100%;
      height: 50px;
      line-height: 50px;
      text-indent: 50px;
      border-bottom: 1px solid #C0C4CC;
      .answer_inline {
        width: 50%;
        display: flex;
        .answer_line_txt {
          width: 150px;
          text-indent: 20px;
          background: #3ae2c4;
        }
      }
    }
    p {
      line-height: 30px;
      text-indent: 50px;
    }
  }
  .editer {
    width: 80%;
  }
  .terror {
    span {
      display: inline-block;
      color: #3ae2c4;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
</style>

<style>
  .edit_container {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
  .ql-editor{
      height:200px;
    }
</style>